// extracted by mini-css-extract-plugin
export var container = "_lx-0";
export var segment = "_lx-2";
export var segmentActive = "_lx-3";
export var track = "_lx-1";